import {autoserialize} from 'cerialize';
import {IResponseModel} from '../interfaces/response-model.interface';

export class SignedUrlModel implements IResponseModel {
    @autoserialize public signedUrl: string;
}
